import { createFileRoute } from "@tanstack/react-router";
import { EmailVerifiedPage } from "src/components/views/emailVerified/EmailVerifiedPage.tsx";

export const Route = createFileRoute("/emailVerified")({
	component: EmailVerifiedPage,
});
